<div
  class="menu-panel"
  [class.open]="isOpen() && !isClosing()"
  [class.closing]="isClosing()"
  #burgerPanel
>
  <div class="close" (click)="closeMenu()">
    <p>Informationen</p>
    <i class="material-icons">close</i>
  </div>

  <div class="menu-content">
    <h4>Meine NV - Serviceline</h4>
    <a class="tel-nr-link" href="tel:0274225010">02742 - 25010</a>
    <br /><br /><br />

    <h4>Informationen</h4>
    <a (click)="routerService.navigateInfosMeineNV()">Informationen zu MEINE NV</a><br />
    <a (click)="routerService.navigateFAQ()">FAQ</a>
    <br /><br /><br />

    <h4>Rechtliches</h4>
    <a (click)="routerService.navigateNutzungsbedingungen()">Nutzungsbedingungen</a><br />
    <a (click)="routerService.navigateBarrierefreiheit()">Barrierefreiheit</a><br />
    <a (click)="routerService.navigateDatenschutz()">Datenschutz</a><br />
    <a (click)="routerService.navigateImpressum()">Impressum</a><br />
  </div>


  <div class="decorative-border">
    <span>Die Niederösterreichische Versicherung</span>
  </div>
</div>
